import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { FileText, X } from 'lucide-react';

interface EscrituraFilterProps {
  escrituraFilter: string;
  onEscrituraFilterChange: (filter: string) => void;
  onClearFilter: () => void;
}

const EscrituraFilter: React.FC<EscrituraFilterProps> = ({
  escrituraFilter,
  onEscrituraFilterChange,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-2">
        <FileText className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por escrituras</span>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Estado de escritura</label>
          <Select value={escrituraFilter || 'todas'} onValueChange={onEscrituraFilterChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Seleccionar estado" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todas">Todas</SelectItem>
              <SelectItem value="sin_firmar">Sin firmar</SelectItem>
              <SelectItem value="firmado">Firmado</SelectItem>
              <SelectItem value="firmado_presentado">Firmado y presentado</SelectItem>
              <SelectItem value="firmado_sin_presentar">Firmado sin presentar</SelectItem>
              <SelectItem value="inscripta">Inscripta</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600 invisible">Acciones</label>
          <div className="flex gap-2">
            <Button
              onClick={onClearFilter}
              variant="outline"
              size="sm"
              className="px-3"
              disabled={!escrituraFilter || escrituraFilter === 'todas'}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EscrituraFilter;